import React, { useState, useEffect, useRef } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { updateAttendance, fetchStudentName } from '../GoogleSheetsService';
import { format } from 'date-fns';
import './QRScanner.css';

const QRScanner = () => {
  const [scanResults, setScanResults] = useState([]);
  const [scanning, setScanning] = useState(false);
  const catechistFullName = localStorage.getItem('catechistFullName') || 'Giáo lý viên';
  const scannerRef = useRef(null);

  // Function to check if current time is between 9:00 and 11:00
  const isCatechismTime = () => {
    const now = new Date();
    const hours = now.getHours();
    return hours >= 9 && hours < 11;
  };

  useEffect(() => {
    console.log('Scanning state changed to:', scanning);
    if (scanning && !scannerRef.current) {
      try {
        scannerRef.current = new Html5QrcodeScanner(
          'reader',
          {
            fps: 10,
            qrbox: { width: 250, height: 250 },
            facingMode: 'environment',
            showTorchButton: true,
            showZoomSlider: true,
          },
          false
        );
        scannerRef.current.render(onScanSuccess, onScanError);
        console.log('Scanner initialized successfully with rear camera');
      } catch (error) {
        console.error('Error initializing scanner:', error);
        addScanResult({
          studentId: 'Lỗi',
          name: 'Lỗi khởi tạo scanner',
          timestamp: new Date(),
          status: 'error'
        });
        setScanning(false);
      }
    } else if (!scanning && scannerRef.current) {
      scannerRef.current.clear();
      console.log('Scanner cleared');
      scannerRef.current = null;
    }
    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear();
        console.log('Scanner cleaned up on unmount');
      }
    };
  }, [scanning]);

  const addScanResult = (result) => {
    setScanResults(prev => {
      if (result.status !== 'processing') {
        const newResults = prev.map(item =>
          item.studentId === result.studentId && item.status === 'processing'
            ? result
            : item
        );
        if (!newResults.some(item => item.studentId === result.studentId)) {
          return [result, ...newResults].slice(0, 10);
        }
        return newResults.slice(0, 10);
      } else {
        return [result, ...prev].slice(0, 10);
      }
    });
  };

  const onScanSuccess = async (decodedText) => {
    if (scannerRef.current) {
      scannerRef.current.clear();
      setScanning(false);
    }
    const studentId = decodedText;
    console.log('Scanned studentId:', studentId);

    const timestamp = new Date();
    const formattedTimestamp = format(timestamp, 'dd/MM/yyyy HH:mm');

    addScanResult({
      studentId,
      name: ' Đang xử lý...',
      timestamp,
      status: 'processing'
    });

    try {
      const success = await updateAttendance(studentId, catechistFullName);
      console.log('Update attendance success:', success);

      if (success) {
        const name = await fetchStudentName(studentId);
        console.log('Fetched student name:', name);
        addScanResult({
          studentId,
          name,
          timestamp,
          status: 'success'
        });
      } else {
        addScanResult({
          studentId,
          name: 'Lỗi cập nhật điểm danh',
          timestamp,
          status: 'error'
        });
      }
    } catch (error) {
      console.error('Error processing scan:', error);
      addScanResult({
        studentId,
        name: 'Lỗi xử lý',
        timestamp,
        status: 'error'
      });
    }
  };

  const onScanError = (error) => {
    console.warn(`Quét lỗi: ${error}`);
  };

  const handleScan = () => {
    setScanning(true);
  };

  return (
    <div className="scan-container">
      <img src="/logo.png" alt="Logo" className="logo-qr" />
      <h2>Giáo lý viên: {catechistFullName}</h2>
      <h3>Điểm danh Thiếu nhi Đi Lễ</h3>
      {isCatechismTime() && (
        <p style={{ color: 'red', margin: '0.5rem 0' }}>
          Cảnh báo: Đây là thời gian Học giáo lý, chuyển sang mục <b>"Điểm danh Học Giáo Lý"</b> để điểm danh.
        </p>
      )}
      <div className="scanner-container">
        <div id="reader" style={{ display: scanning ? 'block' : 'none', width: '100%', maxWidth: '500px' }}></div>
      </div>
      {!scanning && <button onClick={handleScan}>Quét mã QR</button>}

      <div className="scan-results-table">
        <table>
          <thead>
            <tr>
              <th>Thời gian</th>
              <th>ID</th>
              <th>Họ và tên</th>
              <th>Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            {scanResults.map((result, index) => (
              <tr key={index} className={result.status}>
                <td>{format(result.timestamp, 'HH:mm:ss')}</td>
                <td>{result.studentId}</td>
                <td>{result.name}</td>
                <td>
                  {result.status === 'processing' && (
                    <div className="spinner"></div>
                  )}
                  {result.status === 'success' && '✓'}
                  {result.status === 'error' && '✗'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QRScanner;